<template>
  <div style="height:400px;">
    <v-select multiple
              label="name"
              :closeOnSelect="false"
              v-model="selectedRoles"
              push-tags
              :options="roleCollection" />
  </div>
</template>

<script>

  import TCVelikClient from '@/TCVelikClient/TCVelikClient';
  import vSelect from 'vue-select'
  import UserList from "@/views/components/extra-components/users/UserList.vue";
  import { VueTabs, VTab } from "vue-nav-tabs";

  export default {
    data() {
      return {
        email: "",
        ShareTypeObject: null,
        roleCollection: [],
        isLoading:true,
        selectedRoles: null
      }

    },

    watch: {
      'selectedRoles': function (newRoles, oldRoles) {
        if (oldRoles == null) {
          return;
        }
        if (newRoles && oldRoles) {
          if (newRoles.length > oldRoles.length) {
            this.assignItemToRole(newRoles.filter(x => !oldRoles.includes(x)));
          }
          else if (newRoles.length < oldRoles.length) {
            this.UnassignRoleFromItem(oldRoles.filter(x => !newRoles.includes(x)));
          }
        }
      }
    },


    props: ["shareObjectType", "shareObjectId"],
    mounted() {
      this.LoadRoles();
      this.LoadAssignedRoles()
    },
    methods: {
      LoadAssignedRoles() {

        var instance = this;
        const query = `
  query AssignedToRoleItems($itemId: Int!, $shareObjectType: SharedObjectTypeEnum!) {
    assignedToRoleItems(where: { itemId: { eq: $itemId }, shareObjectType: { eq: $shareObjectType } }) {
        userRole {
            id,
            name
        }

    }
}
     `;
        var type = "ONBOARDING"
        if (this.shareObjectType != 0) {
          type = "SPACE"
        }

        const req = {
          query,
          variables: {
            itemId: this.shareObjectId,
            shareObjectType: type
          }
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.selectedRoles = response.data.data.assignedToRoleItems.map(el => el.userRole)
          }
          else if (response && response.data && response.data.errors) {
            alert(instance.$t('ErrorFetchingAssignedRoles'));
          }
        });

      },

      LoadRoles() {

        var instance = this;
        const query = `
     query RolesWithUsers {
    rolesWithUsers {
        id
        name
        normalizedName
        concurrencyStamp
        providerName
    }
}
     `;

        const req = {
          query
        };

        TCVelikClient.PostRelative("/api/graphql", req, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        }).then(function (response) {
          if (response && response.data && response.data.data) {
            instance.roleCollection = response.data.data.rolesWithUsers
          }
          else if (response && response.data && response.data.errors) {
            alert(instance.$t('ErrorFetchingRoles'));
          }
        });

      },
      assignItemToRole(role) {
        var instance = this;

        TCVelikClient.PostRelative("/api/share/AssignRoleToItem",
          {
            itemId: instance.shareObjectId,
            roleId: role[0].id,
            shareObjectType: instance.shareObjectType
          })
          .then(function (response) {
            if (response) {
              instance.$vs.notify({
                title: instance.$t('SuccessfullyAssignedItem'),
                color: "success",
                iconPack: "feather",
                position: "top-center",
                icon: "icon-check-circle",
              });
            }
          }).catch(err => {
            if (err.response.status == 400) {
              instance.$vs.notify({
                title: instance.$t('NoSuchRoleExists'),
                color: "danger",
                iconPack: "feather",
                position: "top-center",
                icon: "icon-check-circle",
              });
            }
            else {
              instance.$vs.notify({
                title: instance.$t('ProblemAssigningItemToRole'),
                color: "danger",
                iconPack: "feather",
                position: "top-center",
                icon: "icon-check-circle",
              });
            }

          });
      },

      UnassignRoleFromItem(role) {
        var instance = this;
        TCVelikClient.PostRelative("/api/share/UnassignRoleToItem",
          {
            itemId: instance.shareObjectId,
            roleId: role[0].id,
            shareObjectType: instance.shareObjectType
          })
          .then(function (response) {
            if (response) {
              instance.$vs.notify({
                title: instance.$t('SuccessfullyUnassignedItem'),
                color: "success",
                iconPack: "feather",
                position: "top-center",
                icon: "icon-check-circle",
              });
            }
          }).catch(err => {
            if (err.response.status == 400) {
              instance.$vs.notify({
                title: instance.$t('NoSuchRoleExists'),
                color: "danger",
                iconPack: "feather",
                position: "top-center",
                icon: "icon-check-circle",
              });
            }
            else {
              instance.$vs.notify({
                title: instance.$t('ProblemAssigningItemToRole'),
                color: "danger",
                iconPack: "feather",
                position: "top-center",
                icon: "icon-check-circle",
              });
            }

          });
      },

    },

          

    components: {
      vSelect,
      UserList,
      VueTabs,
      VTab
    }
  }
</script>

<style scoped>

 
</style>

